export const getOptionsByEnum = (enumType: any) => {
    return Object.keys(enumType).map((key) => {
        return {
            value: enumType[key],
            label: key,
        }
    })
}
